import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=1d6d62bc&scoped=true&lang=pug&"
var script = {}
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=1d6d62bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6d62bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d6d62bc')) {
      api.createRecord('1d6d62bc', component.options)
    } else {
      api.reload('1d6d62bc', component.options)
    }
    module.hot.accept("./FooterComponent.vue?vue&type=template&id=1d6d62bc&scoped=true&lang=pug&", function () {
      api.rerender('1d6d62bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FooterComponent.vue"
export default component.exports